import React from 'react';
import { Modal, message, Row, Table, Space } from 'antd';
import { SettingOutlined, EditOutlined, BellOutlined } from '@ant-design/icons';
import NavItem from '../../../components/nav-item';
import AppIconGroup from '../../../components/app-icon-group';
import dayjs from 'dayjs';
import { getCurrentShopId }  from '../../shop/get-current-shop';
import SwitchShop from '../../shop/switch-shop';
import usePagination from '../../../components/pagination';

const iconStyle = {
    fontSize: 28,
}

const typeMap = {
    'ONCE': '一次性',
    'CYC': '周期性'
}

const statusMap = {
    0: '草稿',
    2: '等待执行',
    3: '部分执行',
    4: '已执行',
    6: '已取消',
}

export default () => {
    const [plans, setPlans] = React.useState([]);
    const [shopId, setShopId] =  React.useState(null);
    const { pagination, setTotal } = usePagination({
        onChange: (page, pageSize) => {
            fetchPlans(page, pageSize)
        },
    });

     React.useEffect(() => {
        getCurrentShopId().then(res => {
            setShopId(res);
        });
    }, []);

    const columns =  [
        {
            title: '名称',
            dataIndex: 'name',
        },
        {
            title: '类型',
            dataIndex: 'type',
            render: (text, record) => {
                return typeMap[text];
            }
        },
        {
            title: '短信内容',
            width: '340px',
            dataIndex: 'smsContent',
            render:  (r, record) => (
                <div>
                    {`【${r?.signName}】${r?.templateContent}`}
                </div>
            )
        },
        {
            title: '执行数据',
            dataIndex: 'times',
            render:  (t, r) => (
                <div>
                    <div>已执行：{r.sent}/{t}次</div>
                    <div>发送短信：{r.smsCount}条</div>
                </div>
            )
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            render: (text) => (
                <span>{dayjs(text).format('YYYY-MM-DD HH:mm')}</span>
            )
        },
        {
            title: '发送时间',
            dataIndex: 'sendTime',
            render: (text) => (
                <span>{dayjs(text).format('YYYY-MM-DD HH:mm')}</span>
            )
        },
        {
            fixed: 'right',
            title: '状态',
            dataIndex: 'status',
            render: (text) => statusMap[ +text],
        },
        {
            fixed: 'right',
            title: '操作',
            key: 'action',
            render: (text, r) => {
                return <Space size="small">
                    <a href={`/promotion/sms/create-task?action=view&taskId=${r.taskId}&shopId=${shopId}`}>详情</a>
                </Space>
            }
                
        }
    ]

    const fetchPlans = async (page = 1, pageSize = 10) => {
        const shopId = await getCurrentShopId();
        const response = await fetch( `/api/promotion/sms/task/list?shopId=${shopId}&page=${page}&pageSize=${pageSize}`);

        const result = await response.json();

        if(result && result.success) {
            setPlans(result.data.rows);
            setTotal(result.data.count);
        }else {
            message.error(result.message);
        }
    }

    React.useEffect(() => {
        fetchPlans();
    }, []);

    return (
        <div>
            <SwitchShop />
            
            {/* 快捷操作 - iOS 风格图标组 */}
            <div className="mt-3 mb-4">
                <AppIconGroup 
                    items={[
                        {
                            id: 1,
                            href: '/promotion/sms/config',
                            title: '通道配置',
                            icon: <SettingOutlined />,
                            color: 'from-blue-500 to-blue-600'
                        },
                        {
                            id: 2,
                            href: '/promotion/sms/create-task',
                            title: '创建计划',
                            icon: <EditOutlined />,
                            color: 'from-green-500 to-green-600'
                        },
                        {
                            id: 3,
                            href: '/promotion/sms/notify-config',
                            title: '通知配置',
                            icon: <BellOutlined />,
                            color: 'from-purple-500 to-purple-600'
                        }
                    ]}
                    cols="3-3-3-3-3"
                />
            </div>

            <h2 className="admin-page-title">短信营销计划列表</h2>
                
                {/* 桌面端：传统表格 */}
                <div className="hidden md:block admin-table-container">
                    <Table 
                        pagination={pagination} 
                        rowKey={'taskId'} 
                        size='small' 
                        columns={columns} 
                        dataSource={plans} 
                        scroll={{ x: 'max-content' }} 
                    />
                </div>
                
                {/* 移动端：卡片列表 */}
                <div className="md:hidden space-y-3">
                    {plans.length === 0 ? (
                        <div className="text-center py-12 text-text-tertiary">
                            暂无数据
                        </div>
                    ) : (
                        plans.map((plan) => (
                            <div key={plan.taskId} className="admin-card p-4 active:scale-[0.98] transition-transform">
                                <div className="flex justify-between items-start mb-2">
                                    <div className="flex-1 min-w-0">
                                        <h3 className="font-semibold text-text-primary truncate">{plan.name}</h3>
                                        <p className="text-xs text-text-tertiary mt-0.5">
                                            {typeMap[plan.type]} · {statusMap[+plan.status]}
                                        </p>
                                    </div>
                                </div>
                                
                                <div className="space-y-1 text-sm mb-3">
                                    {/* 短信内容 */}
                                    <div className="flex justify-between">
                                        <span className="text-text-secondary">短信内容</span>
                                    </div>
                                    <div className="text-xs text-text-primary bg-bg-hover p-2 rounded break-words">
                                        {plan.smsContent ? (
                                            typeof plan.smsContent === 'string' ? plan.smsContent : 
                                            (plan.smsContent.signName && plan.smsContent.templateContent ? 
                                                `【${plan.smsContent.signName}】${plan.smsContent.templateContent}` : '暂无内容')
                                        ) : (
                                            plan.signName && plan.templateContent ? 
                                                `【${plan.signName}】${plan.templateContent}` : '暂无内容'
                                        )}
                                    </div>
                                    <div className="flex justify-between pt-2 border-t border-border-light">
                                        <span className="text-text-secondary">执行情况</span>
                                        <span className="text-text-primary">
                                            已执行 {plan.sent}/{plan.times} 次
                                        </span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className="text-text-secondary">发送短信</span>
                                        <span className="text-text-primary">{plan.smsCount} 条</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className="text-text-secondary">创建时间</span>
                                        <span className="text-text-primary">
                                            {dayjs(plan.createTime).format('YYYY-MM-DD HH:mm')}
                                        </span>
                                    </div>
                                </div>
                                
                                <div className="pt-3 border-t border-border-light flex justify-end">
                                    <a 
                                        href={`/promotion/sms/create-task?action=view&taskId=${plan.taskId}&shopId=${shopId}`}
                                        className="text-primary hover:text-primary-dark text-sm"
                                    >
                                        查看详情
                                    </a>
                                </div>
                            </div>
                        ))
                    )}
                </div>
        </div>
    )
}